import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
// material
import { Tooltip, Stack, TextField, FormControl, InputLabel, Select, Grid, Modal, IconButton, Typography,MenuItem, Button, Box, CardMedia, Tabs, Tab, FormHelperText } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import URLS from '../../../services/urls.service';
import AppCache from '../../../services/AppCache';
import { handleError } from '../../Common/Utils';
import ModalPopUp from '../../Common/ModalPopUp';
import TeamTabPanel from './TeamTabPanel';
import PreferredExecutiveTabPanel from './PreferredExecutiveTabPanel';
import ClientContactDeails from './ClientContactDetails';

// -----------------------------------------------------------------------------------------------------

const style = {
    position: 'absolute',
    top: '50%',
    justifyContent: 'center',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 10,
    p: 4,
};

const AntTabs = styled(Tabs)({
    borderBottom: '1px solid #4e342e',


    position: 'sticky',


    '& .MuiTabs-indicator': {

    },
});
const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
        minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    fontsize: '20px',
    color: '#E7000B',
    Transition: '2s',
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
        color: '#4e342e',

        opacity: 1,
    },
    '&.Mui-selected': {
        color: '#4e342e',

        fontWeight: theme.typography.fontWeightMedium,

    },
    '&.Mui-focusVisible': {
        backgroundColor: '#fff',
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function ClientMasterDetailsComponent({ formik, isError, setpreferredExecutiveValue, clientMaster, isApiChecked, handleApiCheckboxChange, isCheckedCallList, isCheckedActive, handleCheckboxChange,
    handleIsActiveChange, projectStatus, clientGrouping, value, handleChangeValue, hide, handleHide, handleShow, projectStatusId,
    handelSelectedProject, subContactId, handleSelectedSubContact, userId, projectDatatDropDown, projectId, handleSelectedProject,
    executives, selectedExecutives, handleSelectedExecutive, teams, numberOfTeams, maxExecutivesPerTeam, initialExecutiveValue, executiveValue,
    addTeam, handleTeamNameChange, handleProjectChange, initialExecutiveStates, executiveStates, handleExecutivesChange, executiveRoles, executiveCostings,
    handleRoleChange, handleCostingChange, handleActiveCheckboxChange, selectedRadioStates, handleRadioChange, handleErrorCheckboxChange, exeData,
    handleSelectedExecutiveDD, SelectExecutive, selectedPreferredExecutives, handleSave, removeTeam, deleteTeam, handleDelete, executive, department,
    preferredExecutiveValue, handlePreferredSelectedExecutive, SelectPreferredExecutive, DeptValue, handleSelectedDepartment, isHide, selectedDepartment,
    executiveDepartments, currentDepartment, handleExecutiveCheckBoxChange, exeCheckBoxState, rolesData, SelectDepartment, teamPanelData, industry,
    industryData, handleIndustryChange, productFamily, productFamilyData, handleProductFamilyChange, category, categoryData, handleCategoryChange, handleInterState, interState,
    handleName, name, contactEmail, handleContactEmail, contactRemark, handleContactRemark, handleIsBilling, isBilling, contactDetails, addClientDetail, handleClientDetailChange,
    designation, handleContactDesignationChange, billingName, handleBillingName

}) {
    const navigate = useNavigate();

    const [openModalForCancel, setOpenModalCancel] = useState(false);
    const message = {
        forCancel: 'Do you want to cancel ? ',
    };
    const forCancelConfirm = (value) => {
        if (value) {
            navigate('/dashboard/master/clientmaster', { replace: true });
            setOpenModalCancel(false);
        }
        else {
            setOpenModalCancel(false);
        }
    };

    const handelCancelClick = () => {
        setOpenModalCancel(true);

    };

   

    // const handleChangeTab = (event, newValue) => {
    //    setTabValue(newValue);
    // };
    const { handleSubmit, getFieldProps, errors, touched ,values} = formik;

    return (
     <>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <AntTabs value={value} onChange={handleChangeValue} variant="fullWidth" aria-label="basic tabs example">
                        <AntTab onClick={handleShow} label=" Client Master " {...a11yProps(0)} />
                        <AntTab onClick={handleShow} label=" Project Team " {...a11yProps(1)} />
                        <AntTab onClick={handleShow} label=" Preferred Executive " {...a11yProps(2)} />
                        <AntTab onClick={handleShow} label=" Client Contact Details " {...a11yProps(3)} />
                    </AntTabs >
                </Box>
                <TabPanel value={value} index={0}>
                <Stack spacing={3}>
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>

                        <TextField
                            fullWidth
                            size="small"
                            label="Client Name "
                            {...getFieldProps('ClientName')}
                            error={Boolean(touched.ClientName && errors.ClientName)}
                            helperText={touched.ClientName && errors.ClientName}
                        />

                        <TextField
                            fullWidth
                            label="ERP Code"
                            size="small"
                            {...getFieldProps('ERPCode')}
                            error={Boolean(touched.ERPCode && errors.ERPCode)}
                            helperText={touched.ERPCode && errors.ERPCode}
                        />

                        <FormControl
                            fullWidth
                            size="small"
                            error={Boolean(formik.touched.ProjectStatus && formik.errors.ProjectStatus)}
                        >
                            <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Project Status</InputLabel>

                            <Select
                                name="ProjectStatus"
                                value={formik.values.ProjectStatus}
                                label="Project Status"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: '#fbe9e7',
                                            maxHeight: '200px',
                                            width: '200px',
                                        },
                                    },
                                }}
                            >
                                <MenuItem key={0} value="" onClick={() => handelSelectedProject()}>
                                    Select
                                </MenuItem>
                                {projectStatus.map((project) => (
                                    <MenuItem key={project.Id} value={project.Id} onClick={() => handelSelectedProject(project.Id)}> {project.Name}</MenuItem>
                                ))}
                            </Select>
                            <FormHelperText>
                                {formik.touched.ProjectStatus && formik.errors.ProjectStatus}
                            </FormHelperText>
                        </FormControl>

                    </Stack>

                    <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>
                        <TextField
                            fullWidth
                            label="From Email Id"
                            size="small"
                            {...getFieldProps('FromEmailId')}
                            error={Boolean(touched.FromEmailId && errors.FromEmailId)}
                            helperText={touched.FromEmailId && errors.FromEmailId}
                        />
                        <TextField
                            fullWidth
                            label="Sapl Mailer Api"
                            size="small"
                            {...getFieldProps('SaplMailerAPI')}
                            error={Boolean(touched.SaplMailerAPI && errors.SaplMailerAPI)}
                            helperText={touched.SaplMailerAPI && errors.SaplMailerAPI}
                        />


                        <FormControl
                            fullWidth
                            size="small">
                            <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Client Grouping</InputLabel>
                            <Select
                                label="Client Grouping"
                                size="small"
                                value={subContactId}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: '#fbe9e7', // Set the background color here
                                            maxHeight: '200px',
                                            width: '200px',// Set the max height here
                                        }
                                    }
                                }}>
                                <MenuItem key={0} value={""} onClick={() => handleSelectedSubContact()} >Select</MenuItem>
                                {clientGrouping.map((component, index) => (
                                    <MenuItem key={index} value={component.ContactId} onClick={() => handleSelectedSubContact(component.ContactId)}> {component.Name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>


                    </Stack>

                    <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>
                      
                        <FormControl
                            fullWidth
                            size="small">
                            <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Industry</InputLabel>
                            <Select
                                label="Industry"
                                size="small"
                                value={industry}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: '#fbe9e7', // Set the background color here
                                            maxHeight: '200px',
                                            width: '200px',// Set the max height here
                                        }
                                    }
                                }}>
                                <MenuItem key={0} value={""} onClick={() => handleIndustryChange()} >Select</MenuItem>
                                {industryData.map((component, index) => (
                                    <MenuItem key={index} value={component.Id} onClick={() => handleIndustryChange(component.Id)}> {component.Name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl
                            fullWidth
                            size="small">
                            <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Primary Product Family</InputLabel>
                            <Select
                                label="Primary Product Family"
                                size="small"
                                value={productFamily}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: '#fbe9e7', // Set the background color here
                                            maxHeight: '200px',
                                            width: '200px',// Set the max height here
                                        }
                                    }
                                }}>
                                <MenuItem key={0} value={""} onClick={() => handleProductFamilyChange()} >Select</MenuItem>
                                {productFamilyData.map((component, index) => (
                                    <MenuItem key={index} value={component.Id} onClick={() => handleProductFamilyChange(component.Id)}> {component.Name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl
                            fullWidth
                            size="small">
                            <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Category</InputLabel>
                            <Select
                                label="Category"
                                size="small"
                                value={category}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: '#fbe9e7', // Set the background color here
                                            maxHeight: '200px',
                                            width: '200px',// Set the max height here
                                        }
                                    }
                                }}>
                                <MenuItem key={0} value={""} onClick={() => handleCategoryChange()} >Select</MenuItem>
                                {categoryData.map((component, index) => (
                                    <MenuItem key={index} value={component.Id} onClick={() => handleCategoryChange(component.Id)}> {component.Name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>


                    </Stack>

                    <Grid container spacing={2}>
                      
                        <Grid item xs={11.5} sm={11.5} md={7.8} style={{ paddingLeft: 0, paddingTop: 0 }}>

                            <TextField
                                fullWidth
                                label="Remarks"
                                size="small"
                                {...getFieldProps('Remarks')}
                                error={Boolean(touched.Remarks && errors.Remarks)}
                                helperText={touched.Remarks && errors.Remarks}

                            />
                        </Grid>
                        <div style={{ margin: 12 }}>
                            {/* Content */}
                        </div>
                        <Grid item xs={6} sm={4} md={2.3} style={{ paddingTop: 0 }}>
                            <FormGroup>
                                <FormControlLabel

                                    control={<Checkbox checked={isCheckedCallList} onChange={handleCheckboxChange} />}
                                    label="Call List"
                                />
                            </FormGroup>
                        </Grid>
                        <Grid item xs={6} sm={4} md={1.5} style={{ paddingTop: 0 }}>
                            <FormGroup>
                                <FormControlLabel control={<Checkbox checked={isCheckedActive} onChange={handleIsActiveChange} />} label="IsActive" />
                            </FormGroup>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>

                        <Grid item xs={11.5} sm={11.5} md={7.8} style={{ paddingLeft: 0, paddingTop: 0 }}>

                            <TextField
                                fullWidth
                                label="Zylem Api URL"
                                size="small"
                                {...getFieldProps('ZylemAPIUrl')}
                                error={Boolean(touched.ZylemAPIUrl && errors.ZylemAPIUrl)}
                                helperText={touched.ZylemAPIUrl && errors.ZylemAPIUrl}

                            />
                        </Grid>
                        <div style={{ margin: 12 }}>
                            {/* Content */}
                        </div>
                        <Grid item xs={6} sm={4} md={2.3} style={{ paddingTop: 0 }}>
                            <FormGroup>
                                <FormControlLabel

                                    control={<Checkbox checked={isApiChecked} onChange={handleApiCheckboxChange} />}
                                    label="IsApi"
                                />
                            </FormGroup>
                        </Grid>
                       
                    </Grid>
                    <Grid container spacing={2}>
                    <Grid item xs={11.5} sm={11.5} md={7.8} style={{ paddingLeft: 0, paddingTop: 0 }}>
                  
                            <TextField
                                fullWidth
                                label="Address"
                                size="small"
                                multiline
                                maxRows={2}
                                {...getFieldProps('ClientAddress')}
                            />
                        </Grid>
                        <div style={{ margin: 12 }}>
                            {/* Content */}
                        </div>
                        <Grid item xs={6} sm={4} md={2.3} style={{ paddingTop: 0 }}>
                            <FormGroup>
                                <FormControlLabel

                                    control={<Checkbox checked={interState} onChange={handleInterState} />}
                                    label="Inter State"
                                />
                            </FormGroup>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={11.5} sm={11.5} md={7.8} style={{ paddingLeft: 0, paddingTop: 0, display: 'flex', alignItems: 'center' }}>
                            <TextField
                                label="Billing Name"
                                size="small"
                                value={billingName}
                                onChange={handleBillingName }
                                disabled={isBilling}
                                style={{ width: '47.50%', marginRight: 22 }} // Add margin to the right for spacing
                            />
                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox checked={isBilling} onChange={handleIsBilling} />}
                                    label={
                                        <Typography style={{ fontWeight: 'bold' }}>
                                            Billing Name same as Client Name
                                        </Typography>
                                    }
                                />
                            </FormGroup>
                        </Grid>
                       
                    </Grid>

                </Stack>
                </TabPanel>
                <TabPanel value={value} index={1}>
                <TeamTabPanel formik={formik} clientMaster={clientMaster} isError={isError} isCheckedCallList={isCheckedCallList} isCheckedActive={isCheckedActive} handleCheckboxChange={handleCheckboxChange} handleIsActiveChange={handleIsActiveChange} projectStatus={projectStatus} clientGrouping={clientGrouping} value={value} handleChangeValue={handleChangeValue} hide={hide} handleHide={handleHide} handleShow={handleShow} projectStatusId={projectStatusId} handelSelectedProject={handelSelectedProject} subContactId={subContactId} handleSelectedSubContact={handleSelectedSubContact} userId={userId} projectDatatDropDown={projectDatatDropDown} projectId={projectId} handleSelectedProject={handleSelectedProject} executives={executives} selectedExecutives={selectedExecutives} handleSelectedExecutive={handleSelectedExecutive} teams={teams} numberOfTeams={numberOfTeams} maxExecutivesPerTeam={maxExecutivesPerTeam} initialExecutiveValue={initialExecutiveValue} executiveValue={executiveValue} addTeam={addTeam} handleTeamNameChange={handleTeamNameChange} handleProjectChange={handleProjectChange} initialExecutiveStates={initialExecutiveStates} executiveStates={executiveStates} handleExecutivesChange={handleExecutivesChange} executiveRoles={executiveRoles} executiveCostings={executiveCostings} handleRoleChange={handleRoleChange} handleCostingChange={handleCostingChange} handleActiveCheckboxChange={handleActiveCheckboxChange} selectedRadioStates={selectedRadioStates} handleRadioChange={handleRadioChange} handleErrorCheckboxChange={handleErrorCheckboxChange} exeData={exeData} handleSelectedExecutiveDD={handleSelectedExecutiveDD} SelectExecutive={SelectExecutive} handleSave={handleSave} removeTeam={removeTeam} deleteTeam={deleteTeam} handleDelete={handleDelete} executive={executive} department={department} DeptValue={DeptValue} handleSelectedDepartment={handleSelectedDepartment} isHide={isHide} rolesData={rolesData} teamPanelData={teamPanelData}  />
                </TabPanel>

                <TabPanel value={value} index={2}>
                <PreferredExecutiveTabPanel formik={formik} setpreferredExecutiveValue={setpreferredExecutiveValue} clientMaster={clientMaster} isCheckedCallList={isCheckedCallList} isCheckedActive={isCheckedActive} handleCheckboxChange={handleCheckboxChange} handleIsActiveChange={handleIsActiveChange} projectStatus={projectStatus} clientGrouping={clientGrouping} value={value} handleChangeValue={handleChangeValue} hide={hide} handleHide={handleHide} handleShow={handleShow} projectStatusId={projectStatusId} handelSelectedProject={handelSelectedProject} subContactId={subContactId} handleSelectedSubContact={handleSelectedSubContact} userId={userId} projectDatatDropDown={projectDatatDropDown} projectId={projectId} handleSelectedProject={handleSelectedProject} executives={executives} selectedExecutives={selectedExecutives} handleSelectedExecutive={handleSelectedExecutive} teams={teams} numberOfTeams={numberOfTeams} maxExecutivesPerTeam={maxExecutivesPerTeam} initialExecutiveValue={initialExecutiveValue} executiveValue={executiveValue} addTeam={addTeam} handleTeamNameChange={handleTeamNameChange} handleProjectChange={handleProjectChange} initialExecutiveStates={initialExecutiveStates} executiveStates={executiveStates} handleExecutivesChange={handleExecutivesChange} executiveRoles={executiveRoles} executiveCostings={executiveCostings} handleRoleChange={handleRoleChange} handleCostingChange={handleCostingChange} handleActiveCheckboxChange={handleActiveCheckboxChange} selectedRadioStates={selectedRadioStates} handleRadioChange={handleRadioChange} handleErrorCheckboxChange={handleErrorCheckboxChange} exeData={exeData} handleSelectedExecutiveDD={handleSelectedExecutiveDD} SelectExecutive={SelectExecutive} selectedPreferredExecutives={selectedPreferredExecutives} handleSave={handleSave} removeTeam={removeTeam} deleteTeam={deleteTeam} handleDelete={handleDelete} executive={executive} department={department} preferredExecutiveValue={preferredExecutiveValue} handlePreferredSelectedExecutive={handlePreferredSelectedExecutive} SelectPreferredExecutive={SelectPreferredExecutive} DeptValue={DeptValue} handleSelectedDepartment={handleSelectedDepartment} isHide={isHide} selectedDepartment={selectedDepartment} executiveDepartments={executiveDepartments} currentDepartment={currentDepartment} exeCheckBoxState={exeCheckBoxState} handleExecutiveCheckBoxChange={handleExecutiveCheckBoxChange} SelectDepartment={SelectDepartment} teamPanelData={teamPanelData}  />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <ClientContactDeails formik={formik} contactDetails={contactDetails} handleName={handleName} name={name} clientMaster={clientMaster} contactEmail={contactEmail} handleContactEmail={handleContactEmail} selectedDepartment={selectedDepartment}
                    executiveDepartments={executiveDepartments} currentDepartment={currentDepartment} exeCheckBoxState={exeCheckBoxState} handleContactDesignationChange={handleContactDesignationChange } 
                    handleExecutiveCheckBoxChange={handleExecutiveCheckBoxChange} SelectDepartment={SelectDepartment} teamPanelData={teamPanelData} addClientDetail={addClientDetail} handleClientDetailChange={handleClientDetailChange}
                    contactRemark={contactRemark} handleContactRemark={handleContactRemark } setpreferredExecutiveValue={setpreferredExecutiveValue}  isCheckedCallList={isCheckedCallList} isCheckedActive={isCheckedActive}
                    handleCheckboxChange={handleCheckboxChange} handleIsActiveChange={handleIsActiveChange} projectStatus={projectStatus} clientGrouping={clientGrouping} value={value} handleChangeValue={handleChangeValue} designation={designation}
                    hide={hide} handleHide={handleHide} handleShow={handleShow} projectStatusId={projectStatusId} handelSelectedProject={handelSelectedProject} subContactId={subContactId} handleSelectedSubContact={handleSelectedSubContact} userId={userId} projectDatatDropDown={projectDatatDropDown} projectId={projectId} handleSelectedProject={handleSelectedProject} executives={executives} selectedExecutives={selectedExecutives} handleSelectedExecutive={handleSelectedExecutive} teams={teams} numberOfTeams={numberOfTeams} maxExecutivesPerTeam={maxExecutivesPerTeam} initialExecutiveValue={initialExecutiveValue} executiveValue={executiveValue} addTeam={addTeam} handleTeamNameChange={handleTeamNameChange} handleProjectChange={handleProjectChange} initialExecutiveStates={initialExecutiveStates} executiveStates={executiveStates} handleExecutivesChange={handleExecutivesChange} executiveRoles={executiveRoles} executiveCostings={executiveCostings} handleRoleChange={handleRoleChange} handleCostingChange={handleCostingChange} handleActiveCheckboxChange={handleActiveCheckboxChange} selectedRadioStates={selectedRadioStates} handleRadioChange={handleRadioChange} handleErrorCheckboxChange={handleErrorCheckboxChange} exeData={exeData} handleSelectedExecutiveDD={handleSelectedExecutiveDD} SelectExecutive={SelectExecutive} selectedPreferredExecutives={selectedPreferredExecutives} handleSave={handleSave} removeTeam={removeTeam} deleteTeam={deleteTeam} handleDelete={handleDelete} executive={executive} department={department} preferredExecutiveValue={preferredExecutiveValue} handlePreferredSelectedExecutive={handlePreferredSelectedExecutive} SelectPreferredExecutive={SelectPreferredExecutive} DeptValue={DeptValue} handleSelectedDepartment={handleSelectedDepartment} isHide={isHide}  />
            </TabPanel>
         
            {openModalForCancel && <ModalPopUp openCloseValue={setOpenModalCancel} msg={message.forCancel} confirm={forCancelConfirm} />}
            </>
    );
}